export default __webpack_public_path__ + "static/media/WelcomeLeft.463ae069.webp";